// need to change the space between the title and the text. can't do it with CSS
// need to add hover state to cancel button. it should be #FAFAFA
// need to change the space between the CTAs and the text

import { ModalProps } from '@mantine/core';
import StyledModal from '@/components/StyledModal/StyledModal.tsx';
import ModalConfirmationButtons from '@/components/StyledModal/ModalConfirmationButtons.tsx';
import { ReactNode } from 'react';

type props = ModalProps & {
  opened: boolean;
  onClose: () => void;
  title: string;
  onConfirm: () => void;
  onCancel?: () => void;
  message: string | ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmLoading?: boolean;
  closeOnConfirm?: boolean;
  confirmType?: 'primary' | 'delete';
};

const ConfirmationModal = ({
  opened,
  onClose,
  title,
  onConfirm,
  onCancel,
  message,
  confirmText = 'Yes',
  cancelText = 'Cancel',
  confirmLoading = false,
  closeOnConfirm = true,
  confirmType,
  ...modalProps
}: props) => {
  const isStringMessage = typeof message === 'string';

  return (
    <StyledModal
      opened={opened}
      onClose={onClose}
      title={title}
      centered
      withCloseButton={false}
      {...modalProps}
    >
      <div style={{ color: '#757575', lineHeight: '1.4rem', fontSize: '15px' }}>
        {isStringMessage ? <p>{message}</p> : <>{message}</>}
      </div>
      {/*<Text*/}
      {/*  size="15px"*/}
      {/*  style={{*/}
      {/*    color: '#757575',*/}
      {/*    lineHeight: '0.8rem',*/}
      {/*  }}*/}
      {/*>*/}
      {/*  {message}*/}
      {/*</Text>*/}
      <ModalConfirmationButtons
        onClose={onClose}
        onConfirm={onConfirm}
        onCancel={onCancel}
        confirmText={confirmText}
        cancelText={cancelText}
        confirmLoading={confirmLoading}
        closeOnConfirm={closeOnConfirm}
        confirmType={confirmType}
      />
    </StyledModal>
  );
};

export default ConfirmationModal;
